export default "__VITE_ASSET__BOC1k5J4__"